import { NavLink, useLocation } from 'react-router-dom';
import { Home, Receipt, ShoppingBag, TrendingUp, Settings } from 'lucide-react';

const navItems = [
  { path: '/dashboard', icon: Home, label: 'Home' },
  { path: '/bills', icon: Receipt, label: 'Bills' },
  { path: '/spending', icon: ShoppingBag, label: 'Spending' },
  { path: '/forecast', icon: TrendingUp, label: 'Forecast' },
  { path: '/settings', icon: Settings, label: 'Settings' }
];

export const MobileNav = () => {
  const location = useLocation();

  return (
    <nav className="mobile-nav glass" data-testid="mobile-nav">
      <div className="flex items-center justify-around py-2 px-2 max-w-lg mx-auto">
        {navItems.map((item) => {
          const isActive = location.pathname === item.path;
          const Icon = item.icon;
          
          return (
            <NavLink
              key={item.path}
              to={item.path}
              className={`flex flex-col items-center gap-0.5 px-2 py-2 rounded-xl transition-colors ${
                isActive 
                  ? 'text-[#63E6E2]' 
                  : 'text-[#6B7280] hover:text-[#9CA3AF]'
              }`}
              data-testid={`nav-${item.label.toLowerCase()}`}
            >
              <Icon className="w-5 h-5" strokeWidth={isActive ? 2.5 : 2} />
              <span className="text-[10px] font-medium">{item.label}</span>
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
};

export default MobileNav;
